import React, { useState } from 'react';
import { Check, CheckCircle2 } from 'lucide-react';

export default function OnlineOrders({ initialOrders = [], onApproveOrder }) {
  const [orders, setOrders] = useState(initialOrders);

  const approve = (id) => {
    const updated = orders.map(o => o.id === id ? { ...o, status: 'APPROVED' } : o);
    setOrders(updated);
    if (onApproveOrder) onApproveOrder(id);
  };

  return (
    <div style={{ maxWidth: 1440, margin: '0 auto', padding: '1.25rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <div style={{
        background: '#ffffff',
        borderRadius: 14,
        padding: '1rem 1.25rem',
        border: '1px solid #e2e8f0',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 800, color: '#0f172a', margin: 0 }}>
            ग्राहक ऑनलाइन ऑर्डर्स (Customer Self-Service Orders)
          </h2>
          <div style={{ fontSize: '0.75rem', color: '#64748b', marginTop: 2 }}>
            ग्राहकांनी मोबाईल ॲपवरून नोंदवलेल्या एक्स्ट्रा दूध व डेअरी प्रॉडक्ट ऑर्डर्स (ॲप्रूव्ह करताच रनशीटमध्ये अपडेट होतील)
          </div>
        </div>
        <span style={{ background: '#e0f2fe', color: '#0369a1', fontSize: '0.75rem', fontWeight: 800, padding: '4px 10px', borderRadius: 999 }}>
          Customer PWA Add-on
        </span>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        {orders.map(ord => {
          const isPending = ord.status === 'PENDING';
          return (
            <div
              key={ord.id}
              style={{
                background: isPending ? '#fefce8' : '#ffffff',
                borderRadius: 12,
                padding: '1.1rem',
                border: '1px solid ' + (isPending ? '#fde047' : '#e2e8f0'),
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '0.75rem'
              }}
            >
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ fontWeight: 800, fontSize: '0.95rem', color: '#0f172a' }}>{ord.customerName}</span>
                  <span style={{ fontSize: '0.72rem', color: '#64748b' }}>({ord.phone})</span>
                  <span style={{ fontSize: '0.68rem', background: '#f1f5f9', padding: '2px 6px', borderRadius: 4, color: '#475569' }}>
                    {ord.source}
                  </span>
                </div>
                <div style={{ fontSize: '0.85rem', fontWeight: 700, color: '#0284c7', marginTop: 4 }}>
                  ऑर्डर तपशील: {ord.itemDescription}
                </div>
                <div style={{ fontSize: '0.72rem', color: '#64748b', marginTop: 2 }}>
                  वितरण तारीख: <strong>{ord.dateRequested}</strong> • वेळ: {ord.time}
                </div>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: '1.1rem', fontWeight: 800, color: '#0f172a' }}>₹{ord.amount}</div>
                  <div style={{ fontSize: '0.68rem', color: isPending ? '#d97706' : '#16a34a', fontWeight: 700 }}>
                    {isPending ? 'मंजुरी प्रलंबित (Pending)' : 'स्वीकृत (Approved)'}
                  </div>
                </div>

                {isPending ? (
                  <button
                    onClick={() => approve(ord.id)}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 4,
                      padding: '0.5rem 1rem', borderRadius: 8, background: '#16a34a', color: '#fff',
                      fontWeight: 700, fontSize: '0.78rem', border: 'none', cursor: 'pointer'
                    }}
                  >
                    <Check size={14} />
                    <span>स्वीकारा (Approve)</span>
                  </button>
                ) : (
                  <span style={{ display: 'flex', alignItems: 'center', gap: 4, color: '#16a34a', fontSize: '0.78rem', fontWeight: 700 }}>
                    <CheckCircle2 size={16} /> स्वीकृत
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
